import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import {
  Select,
  Input,
  InputPositive,
  InputHidden,
  InputDate
} from 'components/fields'
import {
  required,
  email,
  maxLength,
  minLength
} from 'utils/validation'

const validate = (question, customValidations = [required]) => {

  if(question.isOptional){
    return
  }

  const validations = [...customValidations]
  question.maxLength && validations.push(maxLength(question.maxLength))
  question.minLength && validations.push(minLength(question.minLength))
  return validations
}

class ProfileFields extends Component {
  static propTypes = {
    questions: PropTypes.array.isRequired,
    parentalConsent: PropTypes.bool.isRequired
  }

  setQuestionId = (question, nameRoot, field) => (
    <div key={question.id}>
      <InputHidden
        name={`${nameRoot}.profileQuestion.id`}
        value={question.id}
      />
      {field}
    </div>
  )

  findSuperiorAnswer = (answers, question) =>
    answers.find(item => {
      const id = get(item, 'profileQuestion.id')

      return (
        id && id === get(question, 'showIfOptionSelected.profileQuestion.id')
      )
    })

  idDependencyValid = question => {
    if (question.showIfOptionSelected) {
      const valuesAnswers = get(this.props, 'values.profileQuestionAnswers')

      if (!valuesAnswers || valuesAnswers.length === 0) {
        return false
      }

      const superiorOptionId = get(
        this.findSuperiorAnswer(valuesAnswers, question),
        'profileQuestionOption.id'
      )
      const dependentOptionId = get(question, 'showIfOptionSelected.id')

      return superiorOptionId && superiorOptionId === dependentOptionId
    }
    return true
  }

  renderQuestion = (question, isParentalConsent, index) => {

    const nameRoot = `profileQuestionAnswers[${index}]`

    if(get(question, 'parentalConsentOnly') && !isParentalConsent){
      return
    }

    if(get(question, 'parentalConsentHide') && isParentalConsent){
      return
    }

    if (this.idDependencyValid(question)) {
      switch (question.questionType) {
        case 'DATE':
          return this.renderDate(question, nameRoot)
        case 'EMAIL':
          return this.renderEmail(question, nameRoot)
        case 'INTEGER':
          return this.renderInteger(question, nameRoot)
        case 'OPTIONS':
          return this.renderOptions(question, nameRoot)
        case 'TEXT':
          return this.renderText(question, nameRoot)
        default:
          break
      }
    }

    return null
  }

  renderOptions = (question, nameRoot) => {
    const mappedOptions = question.profileQuestionOptions.map(({
      id,
      translatedText
    }) => ({
      label: translatedText,
      value: id
    }))

    return (
      mappedOptions.length > 0 &&
      this.setQuestionId(
        question,
        nameRoot,
        <div key={question.id}>
          <Select
            name={`${nameRoot}.profileQuestionOption.id`}
            label={question.translatedText}
            options={mappedOptions}
            validate={!question.isOptional && required}
          />
        </div>
      )
    )
  }

  renderText = (question, nameRoot) =>
    this.setQuestionId(
      question,
      nameRoot,
      <Input
        name={`${nameRoot}.valueAsString`}
        label={question.translatedText}
        validate={validate(question)}
      />
    )

  renderEmail = (question, nameRoot) =>
    this.setQuestionId(
      question,
      nameRoot,
      <Input
        name={`${nameRoot}.valueAsString`}
        label={question.translatedText}
        validate={validate(question, [required, email])}
      />
    )

  renderInteger = (question, nameRoot) =>
    this.setQuestionId(
      question,
      nameRoot,
      <InputPositive
        name={`${nameRoot}.valueAsString`}
        label={question.translatedText}
        type="number"
        validate={validate(question)}
      />
    )

  renderDate = (question, nameRoot) =>
    this.setQuestionId(
      question,
      nameRoot,
      <InputDate
        name={`${nameRoot}.valueAsString`}
        label={question.translatedText}
        validate={!question.isOptional && required}
      />
    )

  render() {
    const { questions, parentalConsent } = this.props

    return (
      <div data-testId="profileQuestionContainer">
        {questions &&
          questions.map((item, index) => this.renderQuestion(item, parentalConsent, index))}
      </div>
    )
  }
}

export default ProfileFields
